import {
  first,
  map,
  last,
  each,
  reverse,
} from 'lodash';

export const sport = {
  computed: {
    isServerSport() {
      return [
        5, // Tennis
        20, // Table Tennis
        23, // Volleyball
        31, // Badminton
        34, // Beach volleyball
      ].indexOf(this.idSport) > -1;
    },
    isTennis() {
      return this.idSport === 5;
    },
    isCricket() {
      return this.idSport === 21;
    },
  },
};

export const server = {
  computed: {
    isServer() {
      return !!this.matchStatus.server;
    },
  },
};

export const comparison = {
  methods: {
    isHigher(val1, val2) {
      return +val1 > +val2;
    },
  },
};

export const resultPeriodStandard = {
  computed: {
    resultPeriod() {
      if (!first(this.matchStatus.resultDetails)) {
        let results;
        switch (this.idSport) {
          case 5:
            return [];
          case 21:
            results = this.matchStatus.result.split(':');
            return `${results[1]}/${this.matchStatus.dismissals[1]}`;
          default:
            return this.matchStatus.result;
        }
      }

      let period;
      switch (this.idSport) {
        case 1: // Soccer
        case 6: // Handball
          period = first(this.matchStatus.resultDetails).score;
          break;
        case 5: // Tennis
          period = map(this.matchStatus.resultDetails, (result) => {
            const score = result.score.split(':');

            return score.length > 0 ? [score[0], score[1]] : [];
          });
          break;
        default:
          period = last(this.matchStatus.resultDetails).score;
      }

      return period;
    },
  },
};

export const resultPeriodMedium = {
  computed: {
    resultPeriod() {
      if (!this.status.resultDetails.length && this.idSport !== 21 && this.idSport !== 155) {
        return [['-', '-'], ['-', '-']];
      }

      const period = []; // [[FT], [HT]] || [[CP], [P], [P], ...], check return statement
      const results = this.status.result.split(':');
      switch (this.idSport) {
        case 1: // Soccer
        case 6: // Handball
          period.push(first(this.status.resultDetails).score.split(':')); // HT
          period.push(this.status.result.split(':')); // FT
          break;
        case 155: // Basketball 3x3::no halftime
          period.push(this.status.result.split(':')); // FT
          break;
        case 3: // Baseball
          each(this.status.resultDetails, (result) => {
            period.push(result.score.split(':'));
          });
          period.push(this.status.result.split(':'));
          break;
        case 5: // Tennis
        case 20: // Table Tennis
        case 23: // Volleyball
        case 31: // Badminton
        case 34: // Beach volleyball
          each(this.status.resultDetails, (result) => {
            period.push(result.score.split(':'));
          });
          break;
        case 21: // Cricket
          period.push(['', '']);
          period.push([`${results[0]}/${this.status.dismissals[0]}`, `${results[1]}/${this.status.dismissals[1]}`]);
          break;
        default:
          period.push(last(this.status.resultDetails).score.split(':'));
          period.push(this.status.result.split(':'));
      }

      return this.isServerSport ? period : reverse(period);
    },
  },
};

export const resultPeriodSPlus = {
  computed: {
    resultPeriod() {
      if (!first(this.matchStatus.resultDetails) && this.idSport !== 21) {
        return this.idSport === 5 ? [] : this.matchStatus.result;
      }

      let period;
      const results = this.matchStatus.result.split(':');
      switch (this.idSport) {
        case 1: // Soccer
        case 6: // Handball
          period = first(this.matchStatus.resultDetails).score;
          break;
        case 5: // Tennis
        case 20: // Table tennis
        case 23: // Volleyball
        case 31: // Badminton
        case 34: // Beach volleyball
          period = map(this.matchStatus.resultDetails, (result) => {
            const score = result.score.split(':');
            return score.length > 0 ? [score[0], score[1]] : [];
          });
          reverse(period);
          break;
        case 21: // Cricket
          period = `${results[1]}/${this.matchStatus.dismissals[1]}`;
          break;
        default:
          period = last(this.matchStatus.resultDetails).score;
      }

      return period;
    },
  },
};
